import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * https://jira.vk.team/browse/CLOUDWEB-20339
 *
 * Проверяем до поднятия чекаута, что:
 * 1) у пользователя есть активная подписка (любая – триальная или не-триальная) в текущий момент;
 * 2) сейчас подписки нет, но она была у пользователя за 45 дней до этого (любая – триальная или не-триальная).
 *
 * Если хотя бы одно из двух верно, то показываем пользователю измененный чекаут не на форс-триал, а на покупку тарифа (по условиям после бесплатного периода).
 */
export const trialFromQueryReplacementForPaidUser: Record<string, string> = getFeature('trial-from-query-replacement-for-paid-user') || {};

export const trialFromQueryReplacementForPaidUserDays: number = getFeature('trial-from-query-replacement-for-paid-user-days') || 45;

export const trialFromQueryReplacementForPaidUserTitle: string =
    getFeature('trial-from-query-replacement-for-paid-user-title') ||
    'Бесплатный период недоступен. Возможно, у\u00A0вас уже есть подписка или вы\u00A0недавно отменили\u00A0ее.';
